import { render, staticRenderFns } from "./lossWeightBodyData.vue?vue&type=template&id=64713aec&scoped=true&"
import script from "./lossWeightBodyData.vue?vue&type=script&lang=js&"
export * from "./lossWeightBodyData.vue?vue&type=script&lang=js&"
import style0 from "./lossWeightBodyData.vue?vue&type=style&index=0&id=64713aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64713aec",
  null
  
)

export default component.exports